import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL ?? "http://localhost:5000";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = not logged in
  const [adminMode, setAdminMode] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/api/auth/me`, { withCredentials: true })
      .then((res) => setUser(res.data))
      .catch(() => setUser(null));
  }, []);

  const login = () => {
    window.location.href = `${API}/api/auth/google`;
  };

  const logout = async () => {
    await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true });
    setUser(null);
    setAdminMode(false);
  };

  const isAdmin = user?.is_admin === true;

  return (
    <AuthContext.Provider value={{ user, login, logout, isAdmin, adminMode, setAdminMode }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
